import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2c29cefc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "rankListItem flex align-center"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "weight"
};
var _hoisted_5 = {
  class: "detail"
};
var _hoisted_6 = {
  class: "flex align-center justify-between"
};
var _hoisted_7 = {
  class: "name"
};
var _hoisted_8 = {
  class: "money"
};
var _hoisted_9 = {
  class: "flex align-center justify-between"
};
var _hoisted_10 = {
  class: "text"
};
var _hoisted_11 = {
  class: "text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_collapse_item = _resolveComponent("van-collapse-item");
  return _openBlock(), _createBlock(_component_van_collapse_item, {
    title: _ctx.item.stone_name,
    name: _ctx.item.stone_name,
    class: "mb-2"
  }, {
    title: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.item.stone_name), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item.tot_money) + "元", 1)])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailList, function (iten, indey) {
        return _openBlock(), _createElementBlock("div", {
          key: indey,
          class: "detail-item"
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(iten.stone_name) + " " + _toDisplayString(iten.stone_spec ? '- ' + iten.stone_spec : ''), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(iten.tot_money) + "元", 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, "数量：" + _toDisplayString(iten.net_weight) + _toDisplayString(iten.freight_type), 1), _createElementVNode("span", _hoisted_11, "供应商：" + _toDisplayString(iten.supplier_name), 1)])]);
      }), 128))])];
    }),
    _: 1
  }, 8, ["title", "name"]);
}